module.exports = __webpack_public_path__ + "img/resolve2.fae84834.png";